import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { MatInputModule } from '@angular/material/input';
import { ICellRendererParams } from '@ag-grid-community/core';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { InputNumberDirective } from '../../../../../shared/directives/input-number.directive';

interface ItemQuantityProvider {
	onChangeItemQuantity?: (uniqueRef?: string, itemCount?: number) => void;
	inputParams(params: ICellRendererParams<unknown, unknown>): ItemQuantityParam | undefined;
}

interface ItemQuantityParam {
	uniqueRef: string;
	qtyControl: FormControl;
}

@Component({
	selector: 'copo-item-quantity',
	templateUrl: './item-quantity.component.html',
	styleUrl: './item-quantity.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		InputNumberDirective,
		MatInputModule,
		TranslateModule
	]
})
export class ItemQuantityComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;
	itemQuantityHandler!: (uniqueRef: string, quantity: number) => void;

	params?: ICellRendererParams<unknown, unknown>;
	inputParams: ItemQuantityParam | undefined;
	qtyControl = new FormControl();

	agInit(params: ICellRendererParams<unknown, unknown>) {
		if (!params.colDef) {
			return;
		}
		this.params = params;
		this.inputParams = (<ItemQuantityProvider> params.colDef.cellRendererParams).inputParams(params);
		if (this.inputParams) {
			this.inputParams.qtyControl.setValidators([Validators.required, Validators.min(1)]);
			this.qtyControl = this.inputParams.qtyControl;
		}
		this.itemQuantityHandler = (<ItemQuantityProvider> params.colDef.cellRendererParams)
			.onChangeItemQuantity ?? (() => { /* no-op */ });
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		this.params = params;
		return true;
	}

	quantityOnChange() {
		if (this.inputParams) {
			this.itemQuantityHandler(this.inputParams.uniqueRef, Number(this.inputParams.qtyControl.value));
		}
	}
}
